export const isLengthLessThanOrEqualTo = (max) => (value) => {
  if (value && `${value}`.length > max) {
    return `Must be less than or equal to ${max} characters`;
  }
  return undefined;
};

export default isLengthLessThanOrEqualTo;
